export default __webpack_public_path__ + "static/media/JOSA CLASS-10_SYLLABUS_2025-26.b2e7c04a.pdf";